export default function getDefaultStyle() {
  if (!getDefaultStyle.style) {
    getDefaultStyle.style = {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      borderRadius: '0px 0px 0px 0px',
      borderStyle: 'none',
      borderWidth: '0px',
      bottom: 'auto',
      boxShadow: 'none',
      color: '#CCCCCC',
      fontFamily: '"Courier New", Courier, monospace',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 'normal',
      height: 'auto',
      left: 'auto',
      margin: '0px 0px 0px 0px',
      opacity: 1,
      padding: '0px 0px 0px 0px',
      right: 'auto',
      textAlign: 'left',
      top: 'auto',
      width: 'auto',
      boxSizing: 'border-box',
      zIndex: 1,
      whiteSpace: 'normal',
      display: 'block',
      resize:'none'
    };
  }

  return getDefaultStyle.style;
}
